__webpack_require__.p = "/event-dashboard-webapp/_next/";